import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackAgentChatPanelToggled.meta';

export type UseTrackAgentChatPanelToggledParams = {
  action: 'opened' | 'closed';
  canvas_id: string;
  thread_id?: string;
};

export const useTrackAgentChatPanelToggled = () => {
  const { track } = useAnalyticsUtilities();

  const trackAgentChatPanelToggled = useCallback(
    (params: UseTrackAgentChatPanelToggledParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackAgentChatPanelToggled };
};
